angular.module( 'acme.view.application.resources.equipment.assign', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.controller.resourceAssignment',
  'acme.view.application.resources.equipment.assign.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var resourcesEquipmentAssign = {
        name: 'application.resources.equipment.assign',
        url: '/assign',
        views: {
          "subview-main": {
            controller: 'ResourceAssignmentController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/resources/equipment/assign/assign.tpl.html'
          }
        },
        data: {
          pageTitle: 'Equipment Assignment',
          rule: function(permits) {
            // Allow if state is not in exclusions array
            return (permits.indexOf('application.resources.equipment.assign') !== -1);
          }
        }
      };

    $stateProvider
      .state(resourcesEquipmentAssign);
});
